import { Pipe, PipeTransform } from '@angular/core';
import { InstallerTeamLead, isInstallerLead, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'isInstallerApproved' })
export class IsInstallerApprovedPipe implements PipeTransform {
  transform(user?: User | InstallerTeamLead): boolean {
    return isInstallerLead(user) ? !!user.isApproved : false;
  }
}
